// Library Import
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Text,
  useBoolean,
  useSteps,
  VStack,
  useColorMode,
  useColorModeValue,
  HStack,
  Link,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  AspectRatio,
  Icon,
} from "@chakra-ui/react";
import { FiUser, FiMail, FiLock } from "react-icons/fi";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "@chakra-ui/react";

// Local Imports
import {
  getToken,
  getChallenges,
  loginSignUp,
} from "../../redux/thunks/userThunks.js";
import { redSetToast, redSetLogout } from "../../redux/slices/userSlice.js";
import Toasts from "../../components/Toasts.jsx";
import Navbar from "../../components/Navbar.jsx";

const ChallengeScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [challengeId, setChallengeId] = useState();

  const [loginActive, setLoginActive] = useBoolean(false);
  const [signUpActive, setSignUpActive] = useBoolean(true);

  const {
    userDetails,
    userToken,
    error: userError,
    userLogin,
    loading,
  } = useSelector((state) => state.stateUserReducer);

  const loginHandler = (e) => {
    e.preventDefault();

    if (email && password && loginActive) {
      dispatch(loginSignUp({ email, password }));
    } else if (email && password && name && signUpActive) {
      dispatch(loginSignUp({ email, password, name }));
    } else {
      dispatch(
        redSetToast({ title: "Please enter all details", status: "error" })
      );
    }
  };

  const steps = [
    { title: "First", description: "Login" },
    { title: "Second", description: "Enter Test Code" },
  ];

  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  useEffect(() => {
    if (!userDetails) {
      navigate("/");
    }

    if (userDetails && userToken) {
      setActiveStep(2);
    } else {
      setActiveStep(1);
    }
  }, [userDetails, userToken]);

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [name, setName] = useState();

  return (
    <>
      <Toasts />
      <Navbar active="ChallengeScreen" onOpen={onOpen} />
      {/* Video Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="5xl" isCentered>
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
        <ModalContent minH="80vh" my="auto">
          <ModalHeader>Portal Guide</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <AspectRatio ratio={16 / 9} h="full">
              <iframe
                src="https://www.youtube.com/embed/MbcjyywlfOo?rel=0&modestbranding=1"
                title="Portal Guide"
                allowFullScreen
              />
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Flex
        position="relative"
        minH="100vh"
        w="100%"
        direction="column"
        align="center"
        bg={useColorModeValue("white", "gray.800")}
        overflow="hidden"
      >
        <Flex
          position="absolute"
          inset={0}
          bg={useColorModeValue(
            "radial-gradient(black 1.3px, transparent 1px)",
            "radial-gradient(white 1.3px, transparent 1px)"
          )}
          backgroundSize="25px 25px"
          opacity={0.4}
          sx={{
            maskImage:
              "radial-gradient(ellipse 50% 50% at 50% 50%, #000 70%, transparent 100%)",
            WebkitMaskImage:
              "radial-gradient(ellipse 50% 50% at 50% 50%, #000 70%, transparent 100%)",
          }}
        />

        <Box
          mt="50px"
          w={{ base: "90%", md: "500px" }}
          zIndex={1}
          border={"1.5px solid black"}
          borderRadius={"10px"}
        >
          <Box
            bg={useColorModeValue("white", "gray.700")}
            p={8}
            borderRadius="xl"
            boxShadow={useColorModeValue(
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              "0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.2)"
            )}
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
          >
            <VStack spacing={6} width="100%">
              {/* <Stepper index={activeStep} width="100%">
                {steps.map((step, index) => (
                  <Step key={index}>
                    <StepIndicator
                      bg={
                        index === activeStep
                          ? "black" // active step — solid black
                          : index < activeStep
                          ? "black" // completed step — black
                          : "gray.300" // upcoming step — light gray
                      }
                      color={index <= activeStep ? "white" : "black"}
                      border="2px solid black"
                    >
                      <StepStatus
                        complete={<StepIcon color="white" />}
                        incomplete={<StepNumber />}
                        active={<StepNumber />}
                      />
                    </StepIndicator>

                    <Box flexShrink="0">
                      <StepTitle color="black">{step.title}</StepTitle>
                      <StepDescription color="gray.600">
                        {step.description}
                      </StepDescription>
                    </Box>

                    <StepSeparator
                      borderColor={index < activeStep ? "black" : "gray.300"}
                    />
                  </Step>
                ))}
              </Stepper> */}

              {activeStep === 1 && (
                <VStack spacing={6} width="100%">
                  <VStack spacing={2} textAlign="center">
                    <Heading
                      size="lg"
                      fontWeight="bold"
                      color={useColorModeValue("gray.800", "white")}
                    >
                      {loginActive ? "Welcome Back" : "Create Account"}
                    </Heading>
                    <Text
                      color={useColorModeValue("gray.600", "gray.300")}
                      fontSize="md"
                    >
                      {loginActive
                        ? "Sign in to access our platform"
                        : "Sign up to access our platform"}
                    </Text>
                  </VStack>

                  <Flex gap={4} w="100%">
                    <Button
                      flex={1}
                      size="lg"
                      variant={loginActive ? "solid" : "outline"}
                      colorScheme={loginActive && "black"}
                      bgColor={
                        loginActive && useColorModeValue("black", "gray.600")
                      }
                      color={
                        loginActive && useColorModeValue("white", "gray.600")
                      }
                      onClick={() => {
                        setLoginActive.on();
                        setSignUpActive.off();
                      }}
                      _hover={{ transform: "translateY(-1px)" }}
                      transition="all 0.2s"
                    >
                      Login
                    </Button>
                    <Button
                      flex={1}
                      size="lg"
                      variant={signUpActive ? "solid" : "outline"}
                      colorScheme={loginActive && "black"}
                      bgColor={
                        !loginActive && useColorModeValue("black", "gray.600")
                      }
                      color={
                        !loginActive && useColorModeValue("white", "gray.600")
                      }
                      onClick={() => {
                        setLoginActive.off();
                        setSignUpActive.on();
                      }}
                      _hover={{ transform: "translateY(-1px)" }}
                      transition="all 0.2s"
                    >
                      Sign Up
                    </Button>
                  </Flex>

                  <form onSubmit={loginHandler} style={{ width: "100%" }}>
                    <VStack spacing={4} w="100%">
                      {signUpActive && (
                        <InputGroup>
                          <InputLeftElement pointerEvents="none">
                            <FiUser
                              color={useColorModeValue("gray.500", "gray.400")}
                            />
                          </InputLeftElement>
                          <Input
                            type="text"
                            placeholder="Your Name"
                            size="lg"
                            onChange={(e) =>
                              setName(e.target.value.toLowerCase())
                            }
                            _focus={{
                              borderColor: "blue.500",
                              boxShadow: "0 0 0 1px #3182ce",
                            }}
                            bg={useColorModeValue("white", "gray.700")}
                            border={"1px solid"}
                            borderColor={"gray.500"}
                            color={useColorModeValue("gray.800", "white")}
                            _placeholder={{
                              color: useColorModeValue("gray.500", "gray.400"),
                            }}
                          />
                        </InputGroup>
                      )}

                      <InputGroup>
                        <InputLeftElement pointerEvents="none">
                          <FiMail
                            color={useColorModeValue("gray.500", "gray.400")}
                          />
                        </InputLeftElement>
                        <Input
                          type="email"
                          placeholder="Email Address"
                          size="lg"
                          onChange={(e) =>
                            setEmail(e.target.value.toLowerCase())
                          }
                          _focus={{
                            borderColor: "blue.500",
                            boxShadow: "0 0 0 1px #3182ce",
                          }}
                          bg={useColorModeValue("white", "gray.700")}
                          border={"1px solid"}
                          borderColor={"gray.500"}
                          color={useColorModeValue("gray.800", "white")}
                          _placeholder={{
                            color: useColorModeValue("gray.500", "gray.400"),
                          }}
                        />
                      </InputGroup>

                      <InputGroup>
                        <InputLeftElement pointerEvents="none">
                          <FiLock
                            color={useColorModeValue("gray.500", "gray.400")}
                          />
                        </InputLeftElement>
                        <Input
                          type="password"
                          placeholder="Password"
                          size="lg"
                          onChange={(e) => setPassword(e.target.value)}
                          _focus={{
                            borderColor: "blue.500",
                            boxShadow: "0 0 0 1px #3182ce",
                          }}
                          bg={useColorModeValue("white", "gray.700")}
                          border={"1px solid"}
                          borderColor={"gray.500"}
                          color={useColorModeValue("gray.800", "white")}
                          _placeholder={{
                            color: useColorModeValue("gray.500", "gray.400"),
                          }}
                        />
                      </InputGroup>

                     {signUpActive ? (
  <Text
    fontSize="xs"
    color="red.400"
    alignSelf="start"
    ml={1}
  >
    Please remember your password for future logins
  </Text>
) : null}

                      <Button
                        type="submit"
                        bgColor={useColorModeValue("black", "gray.600")}
                        color={useColorModeValue("white", "gray.600")}
                        size="lg"
                        w="100%"
                        mt={2}
                        isLoading={loading}
                        loadingText="Please wait"
                        _hover={{ transform: "translateY(-1px)" }}
                        transition="all 0.2s"
                      >
                        {loginActive ? "Sign In" : "Create Account"}
                      </Button>
                    </VStack>
                  </form>
                </VStack>
              )}

              {activeStep === 2 && (
                <VStack spacing={6} width="100%">
                  <VStack spacing={2} textAlign="center">
                    <Heading
                      size="lg"
                      fontWeight="bold"
                      color={useColorModeValue("gray.800", "white")}
                    >
                      Enter Test Code
                    </Heading>
                    <Text
                      color={useColorModeValue("gray.600", "gray.300")}
                      fontSize="md"
                    >
                      Enter your code to start the assessment
                    </Text>
                  </VStack>

                  <InputGroup>
                    <Input
                      placeholder="Enter test code"
                      size="lg"
                      onChange={(e) => setChallengeId(e.target.value.trim())}
                      _focus={{
                        borderColor: "blue.500",
                        boxShadow: "0 0 0 1px #3182ce",
                      }}
                      bg={useColorModeValue("white", "gray.700")}
                      border={"1px solid"}
                      borderColor={"gray.500"}
                      color={useColorModeValue("gray.800", "white")}
                      _placeholder={{
                        color: useColorModeValue("gray.500", "gray.400"),
                      }}
                    />
                  </InputGroup>

                  <Button
                    bgColor={useColorModeValue("black", "gray.600")}
                    color={useColorModeValue("white", "gray.600")}
                    size="lg"
                    w="100%"
                    onClick={() => {
                      if (userToken && challengeId) {
                        navigate(`/challenges/${challengeId}`);
                      } else if (!userToken) {
                        dispatch(
                          redSetToast({
                            title: "Please Sign in first",
                            status: "error",
                          })
                        );
                      }
                    }}
                    _hover={{ transform: "translateY(-1px)" }}
                    transition="all 0.2s"
                  >
                    Start Test
                  </Button>
                </VStack>
              )}
            </VStack>
          </Box>
        </Box>

        {/* Centered Footer */}
        <Flex
          position="fixed"
          bottom={0}
          w="100%"
          py={4}
          px={8}
          borderTop="1px solid"
          borderColor={useColorModeValue("gray.200", "gray.700")}
          bg={useColorModeValue(
            "rgba(255, 255, 255, 0.9)",
            "rgba(26, 32, 44, 0.9)"
          )}
          backdropFilter="blur(10px)"
          justify="center"
          align="center"
          zIndex={1}
        >
          <Box w="100%" maxW="1400px" textAlign="center">
            <Text
              color={useColorModeValue("gray.600", "gray.400")}
              fontSize="sm"
            >
              © {new Date().getFullYear()} Euclideum Solutions Private Limited. All Rights
              Reserved
            </Text>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default ChallengeScreen;
